var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#016E2B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 28C18 28.75 17.79 29.46 17.42 30.06C16.73 31.22 15.46 32 14 32C12.54 32 11.27 31.22 10.58 30.06C10.21 29.46 10 28.75 10 28C10 25.79 11.79 24 14 24C16.21 24 18 25.79 18 28Z",
    stroke: "#016E2B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4414 27.9995L13.4314 28.9895L15.5614 27.0195",
    stroke: "#016E2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7514 16.05C26.5114 16.01 26.2614 16 26.0014 16H16.0014C15.7214 16 15.4514 16.02 15.1914 16.06C15.3314 15.78 15.5314 15.52 15.7714 15.28L19.0214 12.02C20.3914 10.66 22.6114 10.66 23.9814 12.02L25.7314 13.79C26.3714 14.42 26.7114 15.22 26.7514 16.05Z",
    stroke: "#016E2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21V26C31 29 29 31 26 31H16.63C16.94 30.74 17.21 30.42 17.42 30.06C17.79 29.46 18 28.75 18 28C18 25.79 16.21 24 14 24C12.8 24 11.73 24.53 11 25.36V21C11 18.28 12.64 16.38 15.19 16.06C15.45 16.02 15.72 16 16 16H26C26.26 16 26.51 16.01 26.75 16.05C29.33 16.35 31 18.26 31 21Z",
    stroke: "#016E2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21.5H28C26.9 21.5 26 22.4 26 23.5C26 24.6 26.9 25.5 28 25.5H31",
    stroke: "#016E2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.3322a9d9627bb5fdabd43441096c1750.svg";
export { ForwardRef as ReactComponent };